class BrandsUsersListContainer {
  constructor(
    $location,
    $q,
    appErrorHandler,
    appEvents,
    appSession,
    appSessionCapabilities,
    brands,
    BRANDS_EVENTS,
  ) {
    'ngInject';

    this.$location = $location;
    this.$q = $q;
    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.appSession = appSession;
    this.appSessionCapabilities = appSessionCapabilities;
    this.brands = brands;
    this.BRANDS_EVENTS = BRANDS_EVENTS;
    this.loading = false;
    this.canUpdatePermissions = false;
    this.currentUserId = '';
    this.removeSelectionSubscription = appEvents.on(
      BRANDS_EVENTS.select,
      (brand) => {
        this.brand = brand;
        this.selectedId = brand.id;
        this.loadBrand();
      },
    );

    this.removeModalRefreshSubscription = this.appEvents.on(
      this.BRANDS_EVENTS.modal.save,
      () => {
        this.loadBrand();
      },
    );

    this.removeRevokeRefreshSubscription = this.appEvents.on(
      this.BRANDS_EVENTS.revoke.save,
      () => {
        this.loadBrand();
      },
    );

    this.brand = {};
    this.actionsTypes = {
      brandAdminSettings: {
        id: 'brand-admin-settings',
        label: 'Admin settings',
      },
      assignUser: {
        id: 'assign-user',
        label: 'Assign user',
      },
    };
    this.headerActions = [];
  }
  $onInit() {
    this.currentUserId = this.appSession.getSession().user.id;
  }
  $onDestroy() {
    this.removeSelectionSubscription();
    this.removeModalRefreshSubscription();
    this.removeRevokeRefreshSubscription();
  }
  $onChanges({ selectedId }) {
    if (selectedId && selectedId.currentValue) {
      this.loadBrand();
    }
  }
  loadBrand() {
    let result;
    if (this.loading) {
      result = this.$q
      .reject(new Error('The account information is already being requested'));
    } else {
      this.appEvents.emit(this.BRANDS_EVENTS.load.start, this.selectedId);
      this.loading = true;
      result = this.brands.byId(this.selectedId)
      .then((brand) => {
        this.brand = brand;
        this.canUpdatePermissions = this.appSessionCapabilities
        .canUpdateBrandPermissions();
        this.resetHeaderActions();
        this.appEvents.emit(this.BRANDS_EVENTS.load.success, this.brand);
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error loading the account information');
        this.$location.path('/accounts');
        this.appEvents.emit(this.BRANDS_EVENTS.load.error, error);
      })
      .then(() => {
        this.loading = false;
        this.appEvents.emit(this.BRANDS_EVENTS.load.finish);
      });
    }

    return result;
  }
  resetHeaderActions() {
    this.headerActions = [];

    if (this.appSessionCapabilities.canChangeBrandAdminSettings()) {
      this.headerActions.push(this.actionsTypes.brandAdminSettings);
    }

    if (this.appSessionCapabilities.canAssignBrandToNewUser()) {
      this.headerActions.push(this.actionsTypes.assignUser);
    }
  }
  handleHeaderAction(action) {
    switch (action.id) {
    case this.actionsTypes.brandAdminSettings.id:
      this.openAdminSettingsModal();
      break;
    default:
    case this.actionsTypes.assignUser.id:
      this.openAssignModal();
      break;
    }
  }
  openUpdateModal(users) {
    this.appEvents.emit(this.BRANDS_EVENTS.modal.open, this.brand, users, true);
  }
  openAssignModal() {
    this.appEvents.emit(this.BRANDS_EVENTS.modal.open, this.brand, [], false);
  }
  openRevokeModal(users) {
    this.appEvents.emit(this.BRANDS_EVENTS.revoke.open, this.brand, users);
  }
  openViewModal(user) {
    this.appEvents.emit(this.BRANDS_EVENTS.modal.open, this.brand, [user], true);
  }
  openAdminSettingsModal() {
    this.appEvents.emit(this.BRANDS_EVENTS.adminSettings.open, this.brand);
  }
}

export default {
  controller: BrandsUsersListContainer,
  template: `
    <area-placeholder
      ng-if="!$ctrl.selectedId"
      icon="angle-left"
      text="Choose an account from the left"
    ></area-placeholder>
    <brands-users
      ng-if="$ctrl.selectedId"
      loading="$ctrl.loading"
      brand="$ctrl.brand"
      users="$ctrl.brand.user_accounts"
      current-user-id="$ctrl.currentUserId"
      header-actions="$ctrl.headerActions"
      can-update-permissions="$ctrl.canUpdatePermissions"
      on-header-action-clicked="$ctrl.handleHeaderAction(action)"
      on-update="$ctrl.openUpdateModal(users)"
      on-revoke="$ctrl.openRevokeModal(users)"
      on-view="$ctrl.openViewModal(user)"
    ></brands-users>
  `,
  bindings: {
    selectedId: '<',
  },
};
